"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var ContactsDirective = /** @class */ (function () {
    function ContactsDirective() {
        this.restrict = 'A';
        this.controller = ContactsDirectiveController;
        this.controllerAs = 'contacts';
        return this;
    }
    ContactsDirective.create = function () {
        return new ContactsDirective();
    };
    return ContactsDirective;
}());
exports.ContactsDirective = ContactsDirective;
var ContactsDirectiveController = /** @class */ (function () {
    function ContactsDirectiveController() {
        var _this = this;
        this.contactsList = [];
        this.addContact = function () {
            var newContact = new Contact();
            _this.contactsList.push(newContact);
        };
        this.removeContact = function (contact) {
            var index = _.findIndex(_this.contactsList, contact);
            if (_.isNumber(index) && !_.isNaN(index)) {
                _this.contactsList.splice(index, 1);
            }
        };
    }
    return ContactsDirectiveController;
}());
exports.ContactsDirectiveController = ContactsDirectiveController;
var Contact = /** @class */ (function () {
    function Contact(id, email) {
        this.id = id;
        this.email = email;
    }
    return Contact;
}());
exports.Contact = Contact;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGFjdHMuZGlyZWN0aXZlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY29udGFjdHMuZGlyZWN0aXZlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsMEJBQTRCO0FBRTVCO0lBS0k7UUFKTyxhQUFRLEdBQVcsR0FBRyxDQUFDO1FBQ3ZCLGVBQVUsR0FBRywyQkFBMkIsQ0FBQztRQUN6QyxpQkFBWSxHQUFXLFVBQVUsQ0FBQztRQUdyQyxPQUFPLElBQUksQ0FBQztJQUNoQixDQUFDO0lBRU0sd0JBQU0sR0FBYjtRQUNJLE9BQU8sSUFBSSxpQkFBaUIsRUFBRSxDQUFDO0lBQ25DLENBQUM7SUFDTCx3QkFBQztBQUFELENBQUMsQUFaRCxJQVlDO0FBWlksOENBQWlCO0FBYzlCO0lBQUE7UUFBQSxpQkFlQztRQWRVLGlCQUFZLEdBQWMsRUFBRSxDQUFDO1FBRTdCLGVBQVUsR0FBRztZQUNoQixJQUFJLFVBQVUsR0FBWSxJQUFJLE9BQU8sRUFBRSxDQUFDO1lBQ3hDLEtBQUksQ0FBQyxZQUFZLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxDQUFDO1FBQ3ZDLENBQUMsQ0FBQztRQUVLLGtCQUFhLEdBQUcsVUFBQyxPQUFnQjtZQUNwQyxJQUFJLEtBQUssR0FBVyxDQUFDLENBQUMsU0FBUyxDQUFDLEtBQUksQ0FBQyxZQUFZLEVBQUUsT0FBTyxDQUFDLENBQUM7WUFFNUQsSUFBSSxDQUFDLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsRUFBRTtnQkFDdEMsS0FBSSxDQUFDLFlBQVksQ0FBQyxNQUFNLENBQUMsS0FBSyxFQUFFLENBQUMsQ0FBQyxDQUFDO2FBQ3RDO1FBQ0wsQ0FBQyxDQUFBO0lBQ0wsQ0FBQztJQUFELGtDQUFDO0FBQUQsQ0FBQyxBQWZELElBZUM7QUFmWSxrRUFBMkI7QUFzQnhDO0lBQ0ksaUJBQW1CLEVBQVcsRUFBUyxLQUFjO1FBQWxDLE9BQUUsR0FBRixFQUFFLENBQVM7UUFBUyxVQUFLLEdBQUwsS0FBSyxDQUFTO0lBQ3JELENBQUM7SUFDTCxjQUFDO0FBQUQsQ0FBQyxBQUhELElBR0M7QUFIWSwwQkFBTyJ9